import styled from 'styled-components';
import { color, space, font, query } from '@design/templateFns';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Button } from '@components/Button';
import {
  PropertyListingStatusWrapper,
  PropertyCooperativeAgencyStatus,
} from '@components/Card/PropertyListingCard/style';

//
//
// Stage
//
export const Stage = styled.div`
  width: 100%;
  height: 0;
  padding-bottom: 56.25%; // 16:9 aspect ratio
  position: relative;
  overflow: hidden;
  background-color: ${color('gray1')};

  @media screen and (${query.below('tablet')}) {
    padding-bottom: 75%; // 4:3 aspect ratio
  }

  //
  //
  // Modified from default Swiper Styles

  // Slide styles
  .swiper {
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden;
    list-style: none;
    padding: 0;
    /* Fix of Webkit flickering */
    z-index: 1;
  }
  .swiper-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: flex;
    transition-property: transform;
    box-sizing: content-box;
  }

  .swiper-slide {
    flex-shrink: 0;
    width: 100%;
    height: 0;
    padding-bottom: 56.25%; // 16:9 aspect ratio
    position: relative;
    overflow: hidden;
    background-color: ${color('gray1')};

    @media screen and (${query.below('tablet')}) {
      padding-bottom: 75%; // 4:3 aspect ratio
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      position: absolute;
      top: 0;
      left: 0;
    }
  }

  //Previous and Next buttons
  .swiper-button-prev,
  .swiper-button-next {
    position: absolute;
    top: 50%;
    margin-top: 0;
    z-index: 10;
    cursor: pointer;
    color: ${color('bg')};
  }
  .swiper-button-prev.swiper-button-disabled,
  .swiper-button-next.swiper-button-disabled {
    opacity: 1;
    cursor: auto;
    color: ${color('gray3')};
    pointer-events: none;
  }
  .swiper-button-prev.swiper-button-hidden,
  .swiper-button-next.swiper-button-hidden {
    opacity: 0;
    cursor: auto;
    pointer-events: none;
  }
  .swiper-navigation-disabled .swiper-button-prev,
  .swiper-navigation-disabled .swiper-button-next {
    display: none !important;
  }
  .swiper-button-prev,
  .swiper-rtl .swiper-button-next {
    left: ${space('xl')};
    right: auto;

    @media screen and (${query.below('tablet')}) {
      left: ${space('md')};
    }
  }
  .swiper-button-next,
  .swiper-rtl .swiper-button-prev {
    right: ${space('xl')};
    left: auto;

    @media screen and (${query.below('tablet')}) {
      right: ${space('md')};
    }
  }
  .swiper-button-prev:after,
  .swiper-rtl .swiper-button-next:after,
  .swiper-button-next:after,
  .swiper-rtl .swiper-button-prev:after {
    content: none;
  }
  .swiper-button-lock {
    display: none;
  }
`;

export const StyledPropertyListingStatusWrapper = styled(PropertyListingStatusWrapper)`
  top: ${space('xl')};
  left: ${space('xl')};
  right: ${space('xl')};

  @media screen and (${query.below('tablet')}) {
    top: ${space('md')};
    left: ${space('md')};
    right: ${space('md')};
  }
`;

export const StyledPropertyCooperativeAgencyStatus = styled(PropertyCooperativeAgencyStatus)`
  left: unset;
  right: ${space('xl')};

  @media screen and (${query.below('tablet')}) {
    left: unset;
    right: ${space('md')};
  }
`;

//
//
// Listing Images
//
export const ImagesWrapper = styled.div`
  background-color: ${color('gray1')};
`;

//
//
// Floor Plans
//
export const FloorPlanWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;

  .show-slide-number {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1000;
  }

  //
  //
  // Modified from default Swiper Styles

  // Slide styles
  .swiper {
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden;
    list-style: none;
    padding: 0;
    /* Fix of Webkit flickering */
    z-index: 1;
  }
  .swiper-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: flex;
    transition-property: transform;
    box-sizing: content-box;
  }
  .swiper-slide {
    flex-shrink: 0;
    width: 100%;
    height: 0;
    padding-bottom: 56.25%; // 16:9 aspect ratio
    position: relative;
    overflow: hidden;

    @media screen and (${query.below('tablet')}) {
      padding-bottom: 75%; // 4:3 aspect ratio
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      position: absolute;
      top: 0;
      left: 0;
    }
  }

  //Previous and Next buttons
  .swiper-button-prev,
  .swiper-button-next {
    position: absolute;
    top: 50%;
    margin-top: 0;
    z-index: 10;
    cursor: pointer;
    color: ${color('bg')};
  }
  .swiper-button-prev.swiper-button-disabled,
  .swiper-button-next.swiper-button-disabled {
    opacity: 1;
    cursor: auto;
    color: ${color('gray3')};
    pointer-events: none;
  }
  .swiper-button-prev.swiper-button-hidden,
  .swiper-button-next.swiper-button-hidden {
    opacity: 0;
    cursor: auto;
    pointer-events: none;
  }
  .swiper-navigation-disabled .swiper-button-prev,
  .swiper-navigation-disabled .swiper-button-next {
    display: none !important;
  }
  .swiper-button-prev,
  .swiper-rtl .swiper-button-next {
    left: ${space('md')};
    right: auto;
  }
  .swiper-button-next,
  .swiper-rtl .swiper-button-prev {
    right: ${space('md')};
    left: auto;
  }
  .swiper-button-prev:after,
  .swiper-rtl .swiper-button-next:after,
  .swiper-button-next:after,
  .swiper-rtl .swiper-button-prev:after {
    content: none;
  }
  .swiper-button-lock {
    display: none;
  }
`;

export const MediaGalleryNavigation = styled.div`
  display: flex;
  align-items: stretch;
  width: 100%;
  box-sizing: border-box;
  background-color: ${color('gray4')};
  gap: 1px; // Adds gray border between buttons instead of using border-left on each button

  @media screen and (${query.below('tablet')}) {
    gap: 0;
  }

  .mediagallerynavigation-button {
    background-color: ${color('fg')};
    color: ${color('bg')};
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s ease-in-out;

    //remove standard button styles
    border: none;
    padding: ${space('md')} ${space('sm')};
    margin: 0;
    cursor: pointer;
    outline: none;
    appearance: none;
    box-sizing: border-box;

    &:hover {
      background-color: ${color('gray5')};
    }
  }

  .show-slide-number {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 100;
  }

  // Slide styles
  .swiper {
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden;
    list-style: none;
    padding: 0;
    /* Fix of Webkit flickering */
    z-index: 1;
  }
  .swiper-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: flex;
    transition-property: transform;
    box-sizing: content-box;
  }
  .swiper-slide {
    flex-shrink: 0;
    width: ${space('x12')};
    height: 100%;
    position: relative;
    overflow: hidden;

    & + .swiper-slide {
      border-left: 1px solid ${color('gray4')};
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
`;

export const ImagesNavigation = styled.div`
  display: flex;
  width: 0%;
  flex: 1 0 0%;
  align-items: center;

  @media screen and (${query.below('tablet')}) {
    display: none;
  }
`;

export const ImagesNavigationSwiper = styled.div`
  width: 0%;
  flex: 1 0 0%;
  height: 100%;

  .swiper {
    height: 100%;
  }

  .swiper-slide {
    cursor: pointer;
    background-color: ${color('gray3')};

    .image-thumbs {
      opacity: 0.5;
      transition: opacity 0.2s ease-in-out;
    }

    &.swiper-slide-thumb-active {
      .image-thumbs {
        opacity: 1;
      }
    }
  }
`;

export const ImagesNavigationNavButton = styled.button`
  flex: 0 0 auto;
  width: ${space('x6')};
  height: 100%;
`;

export const MediaGalleryNavigationButton = styled.button`
  flex: 0 0 ${space('x12')};
  width: ${space('x12')};
  flex-direction: column;
  justify-content: center;
  gap: 2px;
  transition: background-color 0.2s ease-in-out;

  @media screen and (${query.below('tablet')}) {
    flex: 1 0 0%;
    width: 100%;
  }

  svg {
    width: ${space('x5')};
    height: ${space('x5')};
    margin-bottom: ${space('xs')};
  }
`;

export const MediaGalleryNavigationButtonSpan = styled.span`
  ${font('body-xxs')};
  line-height: 1;
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

//
//
// Temporary Styles while data from API is not available
//
export const ModalWrapper = styled.div`
  width: 100%;
  height: 0;
  padding-bottom: 56.25%; // 16:9 aspect ratio
  background-color: ${color('gray1')};
  position: relative;
`;
export const ModalInnerWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: ${color('gray1')};
  z-index: 1000;

  h2 {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: ${color('gray4')};
    display: block;
  }

  iframe {
    width: 100%;
    height: 100%;
  }
`;

export const Loading = styled(ModalInnerWrapper)`
  p {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: ${color('gray4')};
  }
`;
